export default __webpack_public_path__ + "static/media/Jean_Guichard_Phare_du_Four_Bretagne_40_x_60_cm.0040759b.jpg";